/* =========================================================
   NA LEIBERL – Header
   Suchfeld als Pill rechts neben den Icons (nur Desktop, Styles in na-leiberl-nav.css).
   Das Feld schickt an die normale Suchseite (/search).
   ========================================================= */
(function () {
  'use strict';

  var PLATZHALTER = 'Spruch oder Motiv suchen';

  var LUPE =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 20 20"/>' +
    '</svg>';

  function einbauen() {
    var icons = document.querySelector('header.header .header__icons');
    if (!icons || icons.querySelector('.nl-suche')) return;

    var route = (window.routes && window.routes.search_url) || '/search';
    var form = document.createElement('form');
    form.className = 'nl-suche';
    form.setAttribute('action', route);
    form.setAttribute('method', 'get');
    form.setAttribute('role', 'search');
    form.innerHTML =
      '<label class="visually-hidden" for="NlSuche">Suche</label>' +
      '<input id="NlSuche" class="nl-suche__feld" type="search" name="q" placeholder="' + PLATZHALTER + '" autocomplete="off">' +
      '<input type="hidden" name="options[prefix]" value="last">' +
      '<button type="submit" class="nl-suche__knopf" aria-label="Suchen">' + LUPE + '</button>';

    icons.insertBefore(form, icons.firstChild);
    document.documentElement.classList.add('nl-hat-suche');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', einbauen);
  else einbauen();
})();
